import styled from "styled-components"
import maskGroup from '../../assets/images/mask_group.png'


const Page = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100vh;
    justify-content: center;
    align-items: center;
`
const Border = styled.div`
    border-style: solid;
    border-width: 35px;
    /* box-shadow: 0px 0px 2px 2px #436ab2; */
    border-color: #436ab2;
`
const ManagerImage = styled.div`
    display: flex;
    flex-direction: row;
`
const DivisiontagImg = styled.div`
    background-image: url(${maskGroup});
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        height: 100vh;
    /* max-width:fit-content; */
`
const Divisiontag = styled.div`
      max-width:fit-content;
`

const Border2 = styled.div`
    border-style: solid;
    border-radius: 30px;
    /* border-width: 35px; */
    border-color: #436ab2;
    box-shadow: 0 0 0 10em #436ab2;
`

const Alert = styled.div`
    display: flex;
    flex-direction: column;
    padding: 18px;
    border-radius: 8px;
    /* box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.15); */
    min-width: 500px;
`

const InputContainer = styled.div`
  display: flex;
  margin-bottom: 4px;
`;

const PasswordIndicator = styled.img`
    height: 30px;
    margin-top: 33.5px;
    border-bottom: 2px solid #436ab2;
    padding-bottom: 6px;
`

const Text = styled.p`
  font-family: "Inter";
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color:#4A90E2;
  display: inline;
`
export {Text, PasswordIndicator, InputContainer, Alert, Border2, Divisiontag, DivisiontagImg, ManagerImage, Border, Page }